// Students and parents sign in to their own app (student-panel-madrasaty),
// never this one. Set REACT_APP_STUDENT_PORTAL_URL for production.
export const STUDENT_PORTAL_URL = process.env.REACT_APP_STUDENT_PORTAL_URL || 'http://localhost:3001';
